const axios = require('axios');

import {NXTCMS_URL as baseUrl } from "src/modules/shared/config/config.service"

const DevoirDeConseilService = {
    /**
     * Soumets le formulaire
     * @param data      Les données du formulaire
     * @param params    Les paramètres GET à passer (zone, page, iframe_referer)
     */
    submitForm(data, params = {}) {
        const url = window.location.origin + '/devoir/submit'
        return axios.post(url, data, {params: params})
    },
    /**
     * @param data      Les données du formulaire
     * @param params    Les paramètres GET à passer (zone, page, iframe_referer)
     */
    getProposition(data, params = {}) {
        const url = window.location.origin + '/devoir/proposition'
        return axios.post(url, data, {params: params})
    },
    /**
     * Récupère les paramètres de configuration pour le devoir de conseil
     */
    getParameters() {
        const url = window.location.origin + '/devoir/parameters'
        return axios.get(url)
    },
    /**
     * Récupère les villes associées au code postal
     */
    getCities(postalCode) {
        let url = baseUrl + '/devoir/cities'
        url += '/' + postalCode
        return axios.get(url)
    },
    /**
     * Récupère les informations de l'utilisateur
     */
    getUser() {
        let url = window.location.origin + '/devoir/user'
        return axios.get(url)
    }
}

export default DevoirDeConseilService
